import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'gatsby-link'
import FacebookProvider, { Page } from 'react-facebook';

import style from '../utils/styles'
import { rhythm } from '../utils/typography'
import {Container} from './layouts'

import footerBg from '../assets/footer_bg.jpg'
import iconPhone from '../assets/iconPhone.png'
import iconMail from '../assets/iconMail.png'
import iconMap from '../assets/iconMap.png'

const TheFooter = styled.div`
  background-image: url(${footerBg});
  background-size: cover;
  background-position: top center;
  min-height: 435px;
`
const ContainerF = Container.extend`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`

const FooterColumn = styled.div`
  width: calc(50% - ${rhythm(1 / 2)});
  min-width: 300px;
  padding-top: ${rhythm(1.3)};
  color: white;

  & h4 {
    font-size: ${rhythm(1.3)};
    color: white;
    font-weight: 400;
    text-align: center;
  }

  & p {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    width: 80%;

    & span {
      line-height: 1.4
    }

    & a {
      color: currentColor;
      text-decoration: none;
    }
  }

  & .info-bar {
    padding: ${rhythm(0.5)} ${rhythm(1)};
    justify-content: center;
    background-color: #333;
    border-radius: 4px;
  }

  & img {
    margin-right: ${rhythm(0.5)};
    position: relative;
    top: 0px;
    user-select: none;
  }

  & .fb-footer {
    margin: 0 auto;
    width: 300px;
  }
`

const Copyright = styled.p`
  text-align: center;
  padding: ${rhythm(2)} ${rhythm(1)} ${rhythm(1)};
  color: white;
  margin: 0;
  font-size: ${rhythm(0.75)};
`

class Footer extends React.Component {
  render() {
    return (
      <TheFooter>
        <ContainerF>
          <FooterColumn>
            <h4>Info</h4>
            <p className="info-bar">TIETOA MINUSTA</p>
            <p><img src={iconPhone} /> <a href="tel:050-5288861">050-5288861</a></p>
            <p><img src={iconMail} /><a href="mailto:info@kirstilouko.com">info@kirstilouko.com</a></p>
            <p><img src={iconMap} /> <span>Ruukintie 25 <br />60100 Seinäjoki </span></p>
          </FooterColumn>
          <FooterColumn>
            <h4>Facebook</h4>
            <div className="fb-footer">
              <FacebookProvider appId="114390019275615">
                <Page href="https://www.facebook.com/Terapiapalvelu-Kirsti-Louko-156979377673908/" width="528" />
              </FacebookProvider>
            </div>
          </FooterColumn>
        </ContainerF>
        <Copyright>Copyright 2022 Terapiapalvelu Kirsti Louko. All Rights Reserved.​</Copyright>
      </TheFooter>
    );
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/layouts/footer.js